import { Box, Button, ButtonPriority, TextButton } from '@wix/design-system'
import React, { FC, memo, MouseEventHandler } from 'react'
import { useMediaQuery } from 'react-responsive'

import { LARGE_DESKTOP } from '../../../breakpoints'

type SkipButtonProps = {
  type?: 'TextButton' | 'Button'
  skipButton?: string | null
  onClick?: MouseEventHandler<HTMLElement>
  dataHook?: string
  position?: string
  skin?: 'dark' | 'light'
  priority?: ButtonPriority
  className?: string
}

const TYPES = {
  Button,
  TextButton,
}

export const SkipButton: FC<SkipButtonProps> = memo(
  ({
    skin = 'dark',
    skipButton,
    onClick,
    dataHook,
    position,
    type = 'TextButton',
    priority = 'primary',
    className,
  }) => {
    const isLargeDesktopScreen = useMediaQuery(LARGE_DESKTOP)
    const positionProps = getPositionProps(position)
    const Comp = TYPES[type]

    return (
      <Box position="absolute" zIndex="999" {...positionProps} className={className}>
        <Comp
          priority={priority}
          skin={skin}
          size={isLargeDesktopScreen ? 'medium' : 'small'}
          onClick={onClick}
          dataHook={dataHook}
        >
          {skipButton}
        </Comp>
      </Box>
    )
  },
)

const getPositionProps = (position: SkipButtonProps['position'] = 'topRight') => {
  if (position === 'bottomRight') {
    return { bottom: 0, right: 0, margin: '36px' }
  }
  return { top: 0, right: 0, margin: '45px 42px' }
}
